import { Navigate } from 'react-router-dom';

const CUSTOMER_CONTEXT_KEY = 'gng_customerContext';

/**
 * Wraps owner routes. If user is in customer context (signed in from menu, came from order success),
 * redirect them away from owner areas to the menu or home.
 */
export default function OwnerGuard({ children }) {
  if (sessionStorage.getItem(CUSTOMER_CONTEXT_KEY) === '1') {
    const lastSlug = localStorage.getItem('gng_lastVisitedMenu');
    const to = lastSlug ? `/m/${lastSlug}` : '/';
    return <Navigate to={to} replace />;
  }

  return children;
}
